module.exports = __webpack_public_path__ + "img/annotation0.7b6c084e.png";